export default __webpack_public_path__ + "static/media/sv11_en_star_b1.4bcba924.mp3";